import type { IxcPortfolioV1CashBalanceKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const getPortfolioCashBalancePath: EntityPathBuilder<IxcPortfolioV1CashBalanceKeys> = (context) => {
  switch (context.kind) {
    // CashBalance is a singleton so there's no list view
    case 'list':
      return undefined;
    case 'detail': {
      if (!context?.keys?.accountId) {
        return undefined;
      }

      return getResolvedPath('/registration/account/$accountId/cash', context.keys);
    }
  }
};

export function getPortfolioCashBalanceDetailPath(accountId: string | undefined) {
  if (!accountId) {
    return undefined;
  }

  return getPortfolioCashBalancePath({ kind: 'detail', keys: { accountId } });
}
